.atm_fc_usich2.atm_fc_usich2{justify-content:right;}
